import Styled from 'styled-components';

export const TitleTag = Styled.div`
  font-size: 20px;
  font-weight: 500;
  margin: 8px 0;
  color: #45465B;
`;
